import { OverlayTrigger, Stack, Tooltip } from "react-bootstrap";

export function CompleteIndicator() {
  return (
    <div style={{ width: "30px", height: "30px", display: "flex", justifyContent: "center", alignItems: "center" }}>
      <svg
        style={{ marginTop: "-1px" }}
        xmlns="http://www.w3.org/2000/svg"
        width="24px"
        height="24px"
        fill="#EEB111"
        className="bi bi-check-circle-fill"
        viewBox="0 0 16 16">
        <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
      </svg>
    </div>
  )
}

export function ErrorIndicator() {
  return (
    <div style={{ width: "30px", height: "30px", display: "flex", justifyContent: "center", alignItems: "center" }}>
      <svg
        style={{ marginTop: "-1px" }}
        xmlns="http://www.w3.org/2000/svg"
        width="24px"
        height="24px"
        fill="var(--bs-danger)"
        className="bi bi-ban"
        viewBox="0 0 16 16">
        <path d="M15 8a6.97 6.97 0 0 0-1.71-4.584l-9.874 9.875A7 7 0 0 0 15 8M2.71 12.584l9.874-9.875a7 7 0 0 0-9.874 9.874ZM16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0" />
      </svg>
    </div>
  )
}

export function PageBreak() {
  return <div className="PageBreak"> ----- page-break ----- </div>
}

export function HoverTooltip({ title }: { title: string }) {
  return (
    <OverlayTrigger
      trigger={['hover', 'focus', 'click']}
      flip
      overlay={<Tooltip id="tooltip-disabled">{title}</Tooltip>}
    >
      <svg
        fill="#FFF"
        height="30px"
        width="30px"
        focusable="false"
        aria-hidden="true"
        viewBox="0 0 25 25"
        data-testid="HelpOutlineIcon"
        style={{ cursor: 'pointer' }}
      >
        <path d="M11 18h2v-2h-2zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8m0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4"></path>
      </svg>
    </OverlayTrigger>
  )
}

export function SectionIndicators({ tooltipMessage, complete, error }: { tooltipMessage: string; complete: boolean; error?: boolean }) {
  return (
    <Stack direction="horizontal" gap={2} style={{ position: "absolute", right: "1rem", top: "calc(50% - 1.15rem)" }}>
      <HoverTooltip title={tooltipMessage} />
      {error ? <ErrorIndicator /> : complete ? <CompleteIndicator /> : null}
    </Stack>
  )
}